import { campusesSchema } from './campuses.schema.js';
import { defineContent } from './defineContent.js';
import data from './campuses.json';

export const campuses = defineContent(campusesSchema, data);
